import React from "react";
import * as styles from "./FeaturedTermo.module.scss";

const FeaturedTermo = ({ FirtsImg, title, SecondImg, ThirdImg }) => {
  return (
    <div className={styles.img__container}>
      <div className={styles.container__img}>
        <img className={`${styles.img1}`} src={FirtsImg} alt={title} />
        <img className={`${styles.img2}`} src={SecondImg} alt={title} />
        <img className={`${styles.img3} `} src={ThirdImg} alt={title} />
      </div>
      <div className={styles.container__title}>
        <p>{title}</p>
      </div>
    </div>
  );
};

export default FeaturedTermo;
